@if (isMultisiteConsentBox()) {
  <div class="consent-box">
    <ul class="consent-list">
      @for (msg of wspConsentMessages; track msg) {
        <li>
          @if (msg.title) {
            <strong>{{ msg.title }}:</strong>
          }
          {{ msg.message }}
        </li>
      }
    </ul>
  </div>
} @else if (isDowngradeConsentBox()) {
  <div class="downgrade-box">
    {{ 'MULTISITE_CONSENT_BOX.MULTISITE_NO_DOWNGRDE' | translate }}
  </div>
}
